export default __webpack_public_path__ + "static/media/quickstart-step-3.7430d1d9.jpg";